const contractAddress = "0xaf59076C9a85Ecaee0FA832beb14c2a98dcb9AC2";

export default contractAddress;